import * as yup from "yup"

export const validationSchema = yup.object().shape({
  employee_id: yup.string().label("Employee").required(),
  memo: yup.string().label("Memo").required(),
  transaction_date: yup.string().label("Date").required(),
  trx_code: yup.string().defined(),
  location_id: yup.string().label("Location").optional(),
  adjusmentDetail: yup.array().label("List Item").optional().min(1).of(
    yup.object().shape({
      product_id: yup.number().defined(),
      coa_coex_id: yup.number().defined(),
      coa_inventory_id: yup.number().defined(),
      coa_inventory_code: yup.string().defined(),
      coa_inventory_name: yup.string().defined(),
      coa_coex_code: yup.string().defined(),
      coa_coex_name: yup.string().defined(),
      count_detail_id: yup.number().defined(),
    })
  ),
  attach_file: yup.array().label("List Attachment").optional().of(
    yup.object().shape({
      file_path: yup.string().optional(),
      adjustment_id: yup.number().optional()
    })
  )
})

export type FormType = yup.InferType<typeof validationSchema>